import bg from "./styles/scss/img/act_modal/bg.png";
import close from "./styles/scss/img/common/modal-close.png";
import { openBrowser } from "../common";

export default function App({ isShow, onClose }) {
	return (
		<div
			style={{
				position: "absolute",
				right: 0,
				bottom: 0,
				zIndex: 1,
				display: isShow ? "block" : "none",
				width: 320,
				height: 156,
				background: `url(${bg}) center top / cover no-repeat`,
				cursor: "pointer",
			}}
			onClick={() => openBrowser("http://eos.wanjiayizhan.com")}
		>
			<span
				style={{
					position: "absolute",
					right: 10,
					top: 10,
					width: 14,
					height: 14,
					background: `url(${close}) left top no-repeat`,
					cursor: "pointer",
				}}
				onClick={onClose}
			></span>
		</div>
	);
}
